import { CollectionsRounded, FolderRounded, ChevronRightRounded } from "@mui/icons-material";
import { Box, Typography, alpha } from "@mui/material";
import { grey } from "@mui/material/colors";
import { rootArchivePath } from "../data";

const PRIMARY = "#212121";
const SECONDARY = "#0277bd";

const NavItem = ({ icon, label, sublabel, selected, onClick, depth = 0 }) => (
	<Box
		onClick={onClick}
		sx={{
			display: "flex",
			alignItems: "center",
			gap: 1.5,
			px: 1.5,
			py: 1,
			pl: 1.5 + depth * 1.5,
			borderRadius: "10px",
			cursor: "pointer",
			mb: 0.5,
			transition: "all 0.15s ease",
			bgcolor: selected ? alpha(PRIMARY, 0.08) : "transparent",
			"&:hover": { bgcolor: selected ? alpha(PRIMARY, 0.1) : alpha(PRIMARY, 0.04) },
		}}>
		{depth > 0 && <ChevronRightRounded sx={{ fontSize: 14, color: grey[400], flexShrink: 0 }} />}
		<Box
			sx={{
				width: 32,
				height: 32,
				borderRadius: "8px",
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				flexShrink: 0,
				bgcolor: selected ? alpha(PRIMARY, 0.12) : alpha(PRIMARY, 0.06),
				color: selected ? PRIMARY : grey[600],
			}}>
			{icon}
		</Box>
		<Box minWidth={0}>
			<Typography
				variant="body2"
				noWrap
				fontWeight={selected ? 600 : 400}
				fontSize="0.8rem"
				color={selected ? PRIMARY : "text.primary"}>
				{label}
			</Typography>
			{sublabel && (
				<Typography variant="caption" noWrap display="block" color="text.disabled" fontSize="0.7rem">
					{sublabel}
				</Typography>
			)}
		</Box>
	</Box>
);

const ArchiveSideNav = ({ currentPath, currentFolderName, breadcrumbParts, onNavigate }) => {
	return (
		<Box
			width={{ xs: "100%", lg: 260 }}
			flexShrink={0}
			borderRight={{ xs: "none", lg: `1px solid ${alpha(grey[900], 0.08)}` }}
			borderBottom={{ xs: `1px solid ${alpha(grey[900], 0.08)}`, lg: "none" }}
			sx={{ bgcolor: alpha(grey[900], 0.015) }}
			display="flex"
			flexDirection="column">
			<Box px={2} pt={2} pb={1}>
				<Typography variant="overline" fontSize="0.65rem" fontWeight={700} color="text.disabled" letterSpacing={1.2}>
					Navigation
				</Typography>
			</Box>
			<Box px={1} pb={1} flex={1} overflow="auto">
				<NavItem
					icon={<CollectionsRounded sx={{ fontSize: 16 }} />}
					label="Shoot Archive"
					sublabel="Root"
					selected={!currentPath}
					onClick={() => onNavigate("", "")}
				/>
				{breadcrumbParts.map((part, index) => {
					const path = `${rootArchivePath}/${breadcrumbParts.slice(0, index + 1).join("/")}`;
					return (
						<NavItem
							key={path}
							icon={<FolderRounded sx={{ fontSize: 16 }} />}
							label={part}
							selected={currentPath === path}
							onClick={() => onNavigate(path, path)}
							depth={index + 1}
						/>
					);
				})}
			</Box>
			{currentPath && (
				<Box px={2} py={1.5} borderTop={`1px solid ${alpha(grey[900], 0.06)}`}>
					<Typography variant="caption" color="text.disabled" display="block" mb={0.5}>
						Current folder
					</Typography>
					<Typography variant="body2" fontWeight={600} fontSize="0.8rem" noWrap>
						{currentFolderName}
					</Typography>
				</Box>
			)}
		</Box>
	);
};

export default ArchiveSideNav;
